import { PlanNames } from '@/models/Plan.ts';

export const fremiumPlans: PlanNames[] = ['Free'];
export const plusProPlans: PlanNames[] = ['Plus', 'Pro'];
export const enterprisePlans: PlanNames[] = ['Enterprise'];
